import { LoggerService } from '../services/infra/logger/logger.service';

export const extractContinuationTokenFromURL = (url: string, loggerService: LoggerService): string | null => {
  const continuationToken = new URLSearchParams(url.slice(url.indexOf('?'))).get('continuationToken');
  if (!continuationToken) {
    loggerService.error('Failed to extract continuation token from json hal next activity resource page link');
    return null;
  }

  return continuationToken;
};
